import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaCelular = (): TabelaColuna => ({
  Chave: 'celular',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Celular</div>
})
